const REFRESHABLE_PLAYBACK_STATUSES = new Set([
  'live_waiting_upload',
  'waiting_upload',
  'live_uploading',
  'uploading',
  'processing'
]);

const catalogItemKey = item => `${item.contentType}:${item.contentId}`;

const REFRESHABLE_MEDIA_FIELDS = [
  'filesize',
  'merging',
  'playback',
  'thumbnailFallbackUrl',
  'thumbnailPending',
  'thumbnailUrl',
  'videoAvailable',
  'videoComplete'
];

export const catalogItemNeedsThumbnailRefresh = item => {
  if (!item) {
    return false;
  }
  if (item.contentType === 'partner_video') {
    return Boolean(item.thumbnailPending);
  }
  return REFRESHABLE_PLAYBACK_STATUSES.has(
    item.playback && item.playback.status
  );
};

export const mergeCatalogThumbnailUpdates = (currentItems, refreshedItems) => {
  const refreshedByKey = (refreshedItems || []).reduce((updates, item) => {
    updates[catalogItemKey(item)] = item;
    return updates;
  }, {});

  return (currentItems || []).map(currentItem => {
    const refreshedItem = refreshedByKey[catalogItemKey(currentItem)];
    if (!refreshedItem) {
      return currentItem;
    }

    const mediaUpdates = REFRESHABLE_MEDIA_FIELDS.reduce((updates, field) => (
      Object.prototype.hasOwnProperty.call(refreshedItem, field)
        ? {...updates, [field]: refreshedItem[field]}
        : updates
    ), {});
    return {...currentItem, ...mediaUpdates};
  });
};
